// store/store.ts
import { configureStore } from '@reduxjs/toolkit';
import modalReducer from './slices/modalSlice';
import userReducer from './slices/userSlice';
import cartListReducer from './slices/cartListSlice';

// 创建一个工厂函数来创建store实例
export const store = () => {
  return configureStore({
    reducer: {
      modal: modalReducer,
      user: userReducer,
      cartList: cartListReducer,
      // 这里可以添加更多的reducers
    },
  });
};

// 从store中推断出类型
export type AppStore = ReturnType<typeof store>;
export type RootState = ReturnType<ReturnType<typeof store>['getState']>;
export type AppDispatch = ReturnType<typeof store>['dispatch'];